import acceptedCookiePolicy from "../../components/onetrust/cookiePolicy";
import {getWistiaScriptUrl} from '../../components_split/_imports/utils/utils.common';

const loadScripts = (id) => {
    if(!document.getElementById(`wistia-${id}`)) {
        loadJS(`https://fast.wistia.com/embed/medias/${id}.json`, null, null, null, `wistia-${id}`, false);
    }

    if(!document.getElementById('wistia-E-v1')) {
        loadJS(getWistiaScriptUrl(), null, null, null, 'wistia-E-v1', false);
    }
};

const addOptionsClasses = (id, options) => {
    document.querySelectorAll(`[data-provider="wistia"][data-uuid="${id}"] .wistia_embed`).forEach((element) => {
        element.classList.add(...options);
    });
};

const wistiaOnReady = (options) => {
    window._wq = window._wq || [];

    _wq.push({
        id: options.id,
        onReady: function (video) {
            /*
            * This loop avoid conflict with wistia style tag and Vue template, because Wistia append style tag in the component
            * All the styles tags are moved after the footer
             */
            const styles = document.querySelectorAll('.wistia_responsive_wrapper style');

            styles.forEach((element) => {
                const clone = element.cloneNode(true);

                document.querySelector('footer')?.after(clone);
                element.remove();
            });

            options.videoData.onReady(video);
        }
    });
};

const renderWistiaPlayer = videoData => {
    if(typeof loadJS !== 'undefined') {
        window._wq = window._wq || [];

        const id = videoData.id;
        const options = [
            `wistia_async_${id}`
        ];

        acceptedCookiePolicy({
            ifPerformanceCookies: () => {
                options.push('doNotTrack=false');
                options.push('googleAnalytics=true');

                addOptionsClasses(id, options);

                wistiaOnReady({
                    id: videoData.id,
                    videoData: videoData
                });
            },
            ifNoPerformanceCookies: () => {
                options.push('doNotTrack=true');
                options.push('googleAnalytics=false');

                addOptionsClasses(id, options);

                wistiaOnReady({
                    id: videoData.id,
                    videoData: videoData
                });
            }
        });

        loadScripts(videoData.id);
    } else {
        console.error('loadJS is undefined');
    }
};

export { renderWistiaPlayer };